import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AdminsService } from 'src/app/_services/admins/admins.service';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.scss']
})
export class PartnerComponent implements OnInit {
  @ViewChild('closebutton') closebutton: any;
  showEdit: Array<boolean> = [];
 showSide: string = '';
 products!: Array<object>;
 selectedProducts: Array<object> = [];
 headerData: Array<any> = [];
 loading: boolean = true;
 search:boolean=false;
 partnerId:any;
 subscriptions:Subscription[] = [];
 listDropDown:Array<object>=[{name:'All'},{name:'Today'},{name:'Last Week'},{name:'This month'},{name:'This year'}]

 constructor( public _adminservices:AdminsService ,public router: Router,private messageService: MessageService,) { }

////////////////ts/////////////////
globalFilter: string = '';

currentPage: number = 0;
@ViewChild('dt2', { static: false }) dt2?: any;
tableReady = false;

onPageChange(event: any) {
  this.currentPage = event.first;
  console.log(this.currentPage)
  localStorage.setItem('partnerPage', this.currentPage.toString());
}


ngOnInit() {
  const savedPage = localStorage.getItem('partnerPage');
  this.currentPage = savedPage ? +savedPage : 0;
  console.log(this.currentPage)

  //  this.getAllpartners(  )
    //////////////////////////////////////////////////
    if(localStorage.getItem('pageNoPartner')){
    
      let numberF=Number(localStorage.getItem('firstPartner'))

      let numberR=Number(localStorage.getItem('rowsPartner'))
      let number=Number(localStorage.getItem('pageNoPartner'))

     
      this.first=numberF
      this.rows=numberR
      this.pageNumber=number

      this.getAllpartners(  );


      
    }else{
      this.getAllpartners(  );


    }
    //////////////////////////////////////////////////
   this.checkRole();
 }

  /**
  * selectedfromDropDown
  * @param $event string
  * @returns void
  */
 selectedfromDropDown(value:any){

   this.Date=value.name;
   this.getAllpartners()

 }
 /**
  * addItem
  * @param value string
  * @returns void
  */
 addItem(value: string): void {
   this.showSide = value
 }


 statusTenant:any=""
 pageNumber=1;
 pagesize=10;
 totalofPages=0;;
 disablenext=false;
 disableperv=false;
 incrementpage(){

   this.pageNumber+=1;
   if(this.pageNumber<1){
     this.pageNumber=1;

   }
   if(this.pageNumber>= this.totalofPages){
     this.pageNumber=this.totalofPages;

   }
   // this.getAllpartners( );
 }
 decreamentPage(){
   this.pageNumber-=1;
   if(this.pageNumber<1){
     this.pageNumber=1;

   }
   // this.getAllpartners( );

 }
partners=[]
totalRecords=0
first: number = 1;
rows: number = 10;

tiggerPageChange(event: any) {
  this.first = event.first;
  this.rows = event.rows;
  let calcPageNumber = Math.floor(this.first / this.rows) + 1;
  this.pageNumber = calcPageNumber;
     this.getAllpartners(  )

     /////
     localStorage.setItem('firstPartner',this.first.toString())
     localStorage.setItem('pageNoPartner',this.pageNumber.toString())
 
 
     localStorage.setItem('rowsPartner',this.rows.toString())
     /////
    }




 numberpartners=0;
 Date:any="All"
  getAllpartners(  ) {
   this.partners=[]
   this.numberpartners=0
   this.subscriptions.push(this._adminservices.ListPartners( 1,20000,this.Date,this.searchText).subscribe((res:any) => {
    this.partners = res["data"];
    this.totalRecords=res["totalRecords"]

    this.numberpartners = this.partners.length;
    this.totalofPages=res["totalPages"]
//////////////////////////
    const savedPage = localStorage.getItem('partnerPage');
    this.currentPage = savedPage ? +savedPage : 0;
    console.log(this.currentPage) 
    this.tableReady = true;
    ///////////////////////
   }, (error) => {
     console.error('Error fetching owners:', error);
  }))

}
 detailperson(event:any,id: any): void {
   this.showEdit=[]
   event.stopPropagation()

   this.showEdit[id] == true ? this.showEdit[id] = false : this.showEdit[id] = true



  }
  hidecard( ){
   this.showEdit=[]

}
deletepartner() {
 this.subscriptions.push( this._adminservices.DeletePartners(this.partnerId ).subscribe((res) => {
  this.closebutton.nativeElement.click();
  this.messageService.add({ severity: 'success', summary: 'Success', detail: `${res.message}` });

  this.getAllpartners()

}, (err: any) => {

  this.messageService.add({ severity: 'error', summary: 'Error', detail: `${ err.error.message[0]}` });

}))

}
partnersRole:any
is_Super:any
checkRole(){
 const data = localStorage.getItem("user");
  if (data !== null) {

   let parsedData = JSON.parse(data);
    this.is_Super=parsedData.is_Super
   if(parsedData.is_Super==false) {
for(let i=0; i<parsedData.permissions.length;i++){
 if(parsedData.permissions[i].page_Name=="partners"){
   this.partnersRole=parsedData.permissions[i];
 }
}
if(this.partnersRole.p_View==false &&this.is_Super==false) {
 this.gotopage( )
}
}


 }
}
gotopage( ){
 let url: string = "unlegal";
   this.router.navigateByUrl(url);
}
searchText:any=""

searchKey(data: string) {
  debugger
  this.searchText = data;
  this.getAllpartners()
}
searchTextChange:any
searchAction(event: KeyboardEvent) {
  if (this.searchText.trim() === '' && (event.key === 'Backspace' || event.key === ' ')) {
    event.preventDefault();
    return;
}
  this.getAllpartners()

}

display = 'none';

deleteModal(id: any) {
  this.display = 'block';
  this.display = 'flex';
  this.partnerId = id;
}

onCloseHandled() {
  this.display = 'none';
}

ngOnDestroy() {
  for(let i=0;i<this.subscriptions.length;i++)
  this.subscriptions[i].unsubscribe();
}


//////////////////////////////////////////////////////////////////////////////



customSort(event: { data: any[], field: string, order: number }) {
  event.data.sort((a, b) => {
    let valueA = a[event.field];
    let valueB = b[event.field];

    console.log("Before Sorting:", valueA, valueB); // Debugging output

    // ✅ Handle null values properly
    if (valueA == null && valueB == null) return 0;
    if (valueA == null) return event.order;  // Null values should appear last in ascending order
    if (valueB == null) return -event.order; // Null values should appear first in descending order

    // ✅ Convert string dates (like "Mar 5, 2025") into Date objects for sorting
    if (this.isValidDate(valueA) && this.isValidDate(valueB)) {
      let dateA = new Date(valueA);
      let dateB = new Date(valueB);
      let result = (dateA.getTime() - dateB.getTime()) * event.order;

      console.log("Sorted Dates:", dateA, dateB, "Result:", result); // Debugging output

      return result;
    }


      // ✅ التحقق مما إذا كانت القيم تواريخ
      if (this.isDate(valueA) && this.isDate(valueB)) {
        return (new Date(valueA).getTime() - new Date(valueB).getTime()) * event.order;
      }


    // ✅ Handle numeric sorting
    if (!isNaN(valueA) && !isNaN(valueB)) {
      return (parseFloat(valueA) - parseFloat(valueB)) * event.order;
    }

    // ✅ Handle text sorting (case insensitive)
    return valueA.toString().localeCompare(valueB.toString(), undefined, { numeric: true }) * event.order;
  });

  console.log("After Sorting:", event.data.map(item => item[event.field])); // Debugging output after sorting
}




// ✅ دالة تتحقق مما إذا كانت القيمة تاريخًا
isDate(value: any): boolean {
  return !isNaN(Date.parse(value));
}
 

isValidDate(dateString: string): boolean {
  return dateString != null && !isNaN(Date.parse(dateString));
}


 statuses = [
  { label: 'Upcoming', value: 'Upcoming' },
  { label: 'Current', value: 'Current' },
  { label: 'Checked Out', value: 'Checked Out' }

];

getSeverity(status: string): string {
  switch (status) {
    case 'Upcoming': return 'rounded-5 px-3 badge Upcoming';
    case 'Current': return 'rounded-5 px-3 badge Current';
    case 'Checked Out': return 'rounded-5 px-3 badge Cancelled';

    case 'Completed': return 'rounded-5 px-3 badge Completed';
    case 'Approved': return 'rounded-5 px-3 badge Approved';
    case 'Cancelled': return 'rounded-5 px-3 badge Cancelled';
    case 'Pending': return 'rounded-5 px-3 badge Pending';
    case 'Rejected': return 'rounded-5 px-3  badge Rejected';
    case 'CheckedOut': return 'rounded-5 px-3  badge Waiting';
    case 'Waiting': return 'rounded-5 px-3  badge Waiting';

    default: return '';
  }
}



}
